import { OrderChargeType } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getEditChargeFormModelSchema = () =>
	z.object({
		type: z.nativeEnum(OrderChargeType).nullable().optional(),
		dateCreated: z.string().nullable().optional(),
		amount: z
			.number()
			.refine((val) => Number.isFinite(val))
			.optional()
			.nullable(),
		partnerId: z.number().nullable().optional(),
	});

export type EditChargeFormModel = z.infer<
	ReturnType<typeof getEditChargeFormModelSchema>
>;
